export const motorFields = [
  {
    label: "DC Current",
    value: "motor_dc_current",
  },
  {
    label: "DC Voltage",
    value: "motor_dc_voltage",
  },
  {
    label: "MCS Temperature",
    value: "motor_mcs_temperature",
  },
  {
    label: "Motor Speed",
    value: "motor_speed",
  },
  {
    label: "Motor Temperature",
    value: "motor_temperature",
  },
  {
    label: "Motor Throttle",
    value: "motor_throttle",
  },
];

export const batteryFields = [
  {
    label: "Temperature",
    value: "temperature",
  },
  {
    label: "Voltage",
    value: "voltage",
  },
];

export const telemetryFields = [
  {
    label: "Accel X Axis",
    value: "accel_x_axis",
  },
  {
    label: "Accel Y Axis",
    value: "accel_y_axis",
  },
  {
    label: "Accel Z Axis",
    value: "accel_z_axis",
  },
  {
    label: "AI Lean Angle",
    value: "ai_lean_angle",
  },
  {
    label: "AI System Voltage",
    value: "ai_system_voltage",
  },
  {
    label: "AI Temperature",
    value: "ai_temperature",
  },
  {
    label: "AI Voltage Input",
    value: "ai_voltage_input",
  },
];

export const ColumnFields = {
  TELEMETRY: {
    title: "Telemetry",
    key: "telemetry",
    children: [
      // {
      //   title: "Accel X Axis",
      //   key: "ACCEL_X_AXIS",
      // },
      // {
      //   title: "Accel Y Axis",
      //   key: "ACCEL_Y_AXIS",
      // },
      // {
      //   title: "Accel Z Axis",
      //   key: "ACCEL_Z_AXIS",
      // },
      // {
      //   title: "AI Lean Angle",
      //   key: "AI_LEAN_ANGLE",
      // },
      {
        title: "AI System Voltage",
        key: "AI_SYSTEM_VOLTAGE",
      },
      {
        title: "AI Temperature",
        key: "AI_TEMPERATURE",
      },
      {
        title: "AI VBuck",
        key: "AI_VBUCK",
      },
      {
        title: "AI Voltage Input",
        key: "AI_VOLTAGE_INPUT",
      },
      {
        title: "AI VUsr1",
        key: "AI_VUSR1",
      },
      {
        title: "AI VUsr2",
        key: "AI_VUSR2",
      },
      {
        title: "DI Ignition",
        key: "DI_IGNITION",
      },
      {
        title: "DI Main Power",
        key: "DI_MAIN_POWER",
      },
      {
        title: "DI Motion",
        key: "DI_MOTION",
      },
      {
        title: "DI Tamper",
        key: "DI_TAMPER",
      },
      {
        title: "DI User1",
        key: "DI_USR1",
      },
      {
        title: "DI User2",
        key: "DI_USR2",
      },
      {
        title: "DO User1",
        key: "DO_USR1",
      },
      {
        title: "DO User2",
        key: "DO_USR2",
      },
      {
        title: "Accel X Axis",
        key: "ACCEL_X_AXIS",
      },
      {
        title: "Accel Y Axis",
        key: "ACCEL_Y_AXIS",
      },
      {
        title: "Accel Z Axis",
        key: "ACCEL_Z_AXIS",
      },
      {
        title: "AI Lean Angle",
        key: "AI_LEAN_ANGLE",
      },
      {
        title: "Gyro X Axis",
        key: "GYRO_X_AXIS",
      },
      {
        title: "Gyro Y Axis",
        key: "GYRO_Y_AXIS",
      },
      {
        title: "Gyro Z Axis",
        key: "GYRO_Z_AXIS",
      },
    ],
  },
  MOTOR: {
    title: "Motor",
    key: "motor",
    children: [
      {
        title: "Brake",
        key: "MOTOR_BRAKE",
      },
      {
        title: "Cruise",
        key: "MOTOR_CRUISE",
      },
      {
        title: "DC Current",
        key: "MOTOR_DC_CURRENT",
      },
      {
        title: "DC Voltage",
        key: "MOTOR_DC_VOLTAGE",
      },
      {
        title: "Driving Mode",
        key: "MOTOR_DRIVING_MODE",
      },
      {
        title: "Fault Feedback",
        key: "MOTOR_FAULT_FEEDBACK",
      },
      {
        title: "MCS Temperature",
        key: "MOTOR_MCS_TEMPERATURE",
      },
      {
        title: "Motor Parking Sign",
        key: "MOTOR_PARKING_SIGN",
      },
      {
        title: "Motor Ready Sign",
        key: "MOTOR_READY_SIGN",
      },
      {
        title: "Motor Regeneration",
        key: "MOTOR_REGENERATION",
      },
      {
        title: "Motor Reverse",
        key: "MOTOR_REVERSE",
      },
      {
        title: "Side Stand",
        key: "MOTOR_SIDE_STAND",
      },
      {
        title: "Motor Speed",
        key: "MOTOR_SPEED",
      },
      {
        title: "Motor Temperature",
        key: "MOTOR_TEMPERATURE",
      },
      {
        title: "Motor Throttle",
        key: "MOTOR_THROTTLE",
      },
    ],
  },
  BATTERY: {
    title: "Battery",
    key: "battery",
    children: [
      {
        title: "Voltage",
        key: "BATTERY_VOLT",
      },
      {
        title: "Current",
        key: "CURRENT",
      },
      {
        title: "Cell Voltage Max",
        key: "CELL_VOLT_MAX",
      },
      {
        title: "Cell Voltage Min",
        key: "CELL_VOLT_MIN",
      },
      {
        title: "Charge Cycle Count",
        key: "CHG_CYCLE_COUNT",
      },
      {
        title: "SOC",
        key: "SOC",
      },
      {
        title: "SOH",
        key: "SOH",
      },
      {
        title: "DSG Cycle Count",
        key: "DSG_CYCLE_COUNT",
      },
      {
        title: "Temperature Max",
        key: "TEMPERATURE_MAX",
      },
      {
        title: "Temperature Min",
        key: "TEMPERATURE_MIN",
      },
    ],
  },
  LOCATION: {
    title: "Location",
    key: "location",
    children: [
      {
        title: "Altitude",
        key: "ALTITUDE",
      },
      {
        title: "Brg",
        key: "BRG",
      },
      {
        title: "Hdop",
        key: "HDOP",
      },
      {
        title: "Latitude",
        key: "LATITUDE",
      },
      {
        title: "Longitude",
        key: "LONGITUDE",
      },
      {
        title: "Pdop",
        key: "PDOP",
      },
      {
        title: "Speed",
        key: "SPEED",
      },
      {
        title: "Track Sats",
        key: "TRACK_SATS",
      },
      {
        title: "Vdop",
        key: "VDOP",
      },
      {
        title: "View Sats",
        key: "VIEW_SATS",
      },
    ],
  },
};

export const IMU = {
  title: "IMU",
  key: "imu",
  children: [
    {
      title: "Accel X Axis",
      key: "ACCEL_X_AXIS",
    },
    {
      title: "Accel Y Axis",
      key: "ACCEL_Y_AXIS",
    },
    {
      title: "Accel Z Axis",
      key: "ACCEL_Z_AXIS",
    },
    {
      title: "AI Lean Angle",
      key: "AI_LEAN_ANGLE",
    },
    {
      title: "Gyro X Axis",
      key: "GYRO_X_AXIS",
    },
    {
      title: "Gyro Y Axis",
      key: "GYRO_Y_AXIS",
    },
    {
      title: "Gyro Z Axis",
      key: "GYRO_Z_AXIS",
    },
  ],
};
